// --- 在代码最开头添加，用于确认脚本是否被加载 ---
console.log('[INIT] Vograce Collection Filters script has been loaded.');

(function() {
  'use strict';

  console.log('[INIT] Vograce Collection Filters IIFE started.');

  /**
   * 从 <script type="application/json"> 标签中获取数据
   * @param {string} selector - 用于定位 script 标签的选择器
   * @returns {any | null} - 解析后的 JSON 数据，如果失败则返回 null
   */
  function getJsonFromScriptTag(selector) {
    console.log(`[DEBUG] Attempting to find script tag with selector: "${selector}"`);
    
    const scriptTag = document.querySelector(selector);
    
    if (!scriptTag) {
      console.error(`[ERROR] Script tag with selector "${selector}" NOT FOUND in the DOM.`);
      console.log('[INFO] Available script tags of type "application/json":');
      document.querySelectorAll('script[type="application/json"]').forEach((tag, index) => {
        console.log(`  [${index}] Selector suggestion: 'script[type="application/json"]:nth-of-type(${index + 1})'`);
        console.log(`      Content preview: ${tag.textContent.substring(0, 100)}...`);
      });
      return null;
    }

    console.log(`[DEBUG] Found script tag. Attempting to parse its content...`);
    
    const data = JSON.parse(scriptTag.textContent);
    console.log(`[SUCCESS] Successfully parsed JSON data from script tag. Data keys:`, Object.keys(data));
    return data;
  }

  /**
   * 侧边栏菜单的主要逻辑
   */
  function getCollectionMenusData() {
    console.log("[DEBUG] Entering getCollectionMenusData function.");

    try {
      // 从 <script type="application/json"> 标签中获取数据
      console.log(`[DEBUG] Querying for element with selector: "#vograce-collection-filters-data"`);

      // 步骤一：尝试查找元素
      const scriptTag = document.querySelector('#vograce-collection-filters-data');

      // 步骤二：检查元素是否存在
      if (!scriptTag) {
        console.error(`[ERROR] Script tag with ID 'vograce-collection-filters-data' NOT FOUND in the DOM.`);
        console.log('[INFO] Listing all script tags of type "application/json" for inspection:');
        document.querySelectorAll('script[type="application/json"]').forEach((tag, index) => {
          console.log(`  Index ${index}: ID="${tag.id}", Content snippet: "${tag.textContent.substring(0, 100)}..."`);
        });
        return; // 如果没找到，直接返回，不继续执行
      }
      console.log(`[DEBUG] Found script tag with ID 'vograce-collection-filters-data'.`);

      // 步骤三：检查元素的文本内容
      const rawTextContent = scriptTag.textContent;
      console.log(`[DEBUG] Raw text content of the script tag (first 200 chars): "${rawTextContent.substring(0, 200)}..."`);

      // 步骤四：尝试解析 JSON
      console.log(`[DEBUG] Attempting to parse the content as JSON...`);
      const menusData = JSON.parse(rawTextContent);

      console.log(`[SUCCESS] Successfully parsed JSON data. Type: ${typeof menusData}, Keys:`, Object.keys(menusData));

      // --- 后续处理逻辑 ---
      const collectionData = Array.isArray(menusData) ? menusData.filter(
        (menu) => menu.type === "collection_link" || menu.type === "product_link" || menu.type === "collections_link"
      ) : [];

      console.log(`[DEBUG] Filtered collectionData, count: ${collectionData.length}`);

      let html = "";
      collectionData.forEach((item, index) => {
        item.id = index;
        item.url = decodeURIComponent(item.url);
        html += filterHtml(item, index);
      });

      const container = document.querySelector(".collection-filters-container");
      if (container) {
        container.innerHTML = html;
        console.log("[DEBUG] HTML content injected into .collection-filters-container.");
      } else {
        console.warn("[WARN] Container .collection-filters-container not found in the DOM.");
      }

      const containerEl = document.querySelector(".collection-filters-container");
      if (containerEl) {
          containerEl.addEventListener("click", function(e) {
              const clickedItem = e.target.closest(".collection-fitler-item");
              if (!clickedItem) return;

              const id = clickedItem.dataset.id;
              const arrowElement = document.querySelector(`.arrow${id}`);
              if (arrowElement) {
                  arrowElement.classList.toggle("down");
              }
              setCollectionDetail(collectionData, id);
          });
      }

      // 默认展开逻辑
      collectionData.forEach((item) => {
        if (item.current || item.child_active) {
          setCollectionDetail(collectionData, item.id);
        }
      });

    } catch (error) {
      // 捕获所有错误
      console.error('[CRITICAL ERROR] An error occurred inside getCollectionMenusData:', error.message);
      console.error('[CRITICAL ERROR] Stack trace:', error.stack);
    }
  }

  function filterHtml(item) {
    const arrowClass = item.current || item.child_active ? "down" : "";
    const baseHtml = `<div class="collection-fitler-item" data-id="${item.id}">
        <div class="collection-item-title">${item.title}</div>
        <img class="collection-item-img ${arrowClass} arrow${item.id}" src="https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Down.svg?v=1753349471" alt="">
      </div>`;

    if (item.links && item.links.length > 0) {
      return `${baseHtml}<div class="collection-detail-container collectionDetailItem${item.id}"></div>`;
    } else {
      return `<a class="collection-fitler-item" data-id="${item.id}" href="${item.url}">${baseHtml}</a>`;
    }
  }

  function setCollectionDetail(collectionData, id) {
    const detailContainer = document.querySelector(`.collectionDetailItem${id}`);
    if (!detailContainer) return;

    const isExpanded = detailContainer.classList.contains("active");
    if (isExpanded) {
      detailContainer.classList.remove("active");
    } else {
      detailContainer.classList.add("active");
      const selectedItem = collectionData.find((item) => item.id == id);
      if (!selectedItem?.links) return;

      const currentPathIsSelected = window.location.pathname === decodeURIComponent(selectedItem.url);
      const allItemExists = selectedItem.links.some((item) => item.title === "all" && item.url === selectedItem.url);
      
      if (!allItemExists) {
        selectedItem.links.unshift({
          url: selectedItem.url,
          title: "all",
          products_count: selectedItem.products_count,
          current: currentPathIsSelected,
        });
      }

      let html = "";
      selectedItem.links.forEach((item) => {
        html += filterHtmlDetail(item);
      });

      detailContainer.innerHTML = html;
    }
  }

  function filterHtmlDetail(item) {
    const iconSrc = item.current
      ? "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Group_171.svg?v=1753349478"
      : "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Ellipse_3.svg?v=1753349471";

    return `
      <a class="collection-detail" href="${item.url}">
        <img class="collection-detail-img" src="${iconSrc}" alt="">
        <div class="collection-detail-title">${item.title} ${
          item.products_count ? `(${item.products_count})` : ""
        }</div>
      </a>`;
  }

  /**
   * 等待 DOM 加载完成并执行初始化逻辑
   */
  function initializeApp() {
    console.log('[DEBUG] initializeApp function called.');

    // --- 第一部分：排序选择器逻辑 ---
    const sortSelectNew = document.getElementById("SortBy_new");
    if (sortSelectNew) {
      const defaultSortValue = getDefaultSortValue(sortSelectNew);
      sortSelectNew.addEventListener("click", onSortClick);
    }

    function onSortClick(event) {
      const options = sortSelectNew.querySelector(".select-options_new");
      const img = document.querySelector(".sort-by-icon_new");
      const optionItems = sortSelectNew.querySelectorAll(".select-option_new");

      if (options.style.display === "block") {
        options.style.display = "none";
        img.classList.remove("up");
      } else {
        options.style.display = "block";
        img.classList.add("up");
      }

      optionItems.forEach((option) => {
        option.addEventListener("click", (e) => {
          e.stopPropagation();
          const value = option.dataset.value;
          const url = new URL(window.location.href);
          url.searchParams.set("sort_by", value);
          window.location.href = url.toString();
        });
      });
    }

    function getDefaultSortValue(sortSelectElement) {
      return sortSelectElement.getAttribute("data-default-sortby_new");
    }

    // --- 第二部分：侧边栏菜单逻辑 ---
    console.log('[DEBUG] About to call getCollectionMenusData().');
    getCollectionMenusData(); 
    console.log('[DEBUG] getCollectionMenusData() function was called successfully.');

    // --- 第三部分：描述项展开/收起逻辑 ---
    console.log('[DEBUG] About to execute description logic.');
    try {
      const descriptionItem = document.querySelector(".collection__description-item_new");
      const moreButton = document.querySelector(".collection__filters_More");
      const toggleImage = document.querySelector(".collection__filters_More-img");

      if (!descriptionItem || !moreButton || !toggleImage) {
        console.warn("Required elements for description expansion not found.");
        return;
      }

      function checkOverflow(element) {
        return element.scrollHeight > element.offsetHeight;
      }

      function updateMoreButtonVisibility() {
        if (checkOverflow(descriptionItem)) {
          moreButton.style.display = 'block';
        } else {
          moreButton.style.display = 'none';
        }
      }

      descriptionItem.classList.add('line-clamp3');
      updateMoreButtonVisibility();

      moreButton.addEventListener("click", (event) => {
        descriptionItem.classList.toggle("expanded");
        if (descriptionItem.classList.contains("expanded")) {
          toggleImage.classList.add("up");
        } else {
          toggleImage.classList.remove("up");
        }
      });
      console.log('[DEBUG] Description logic executed successfully.');
    } catch (e) {
      console.error('[CRITICAL ERROR] Error in description logic:', e.message, e.stack);
    }

    // --- 第四部分：标签页切换逻辑 ---
    const activeTabElement = document.querySelector(".search_tab_active");
    const currentTab = activeTabElement ? activeTabElement.dataset.tab : null;

    if (!currentTab) {
      const sortFilterItem = document.querySelector(".collection-filter__item--sort");
      if (sortFilterItem) sortFilterItem.style.display = 'block';
      return;
    }

    function updateFilterVisibility(tab) {
      const sortFilterItem = document.querySelector(".collection-filter__item--sort");
      if (!sortFilterItem) return;
      sortFilterItem.style.display = tab === "search_tab_products" ? 'block' : 'none';
    }

    updateFilterVisibility(currentTab);

    document.querySelectorAll(".search_tab-button").forEach(button => {
      button.addEventListener("click", function (event) {
        const tab = this.dataset.tab;
        document.querySelectorAll(".search_tab-content").forEach(content => content.style.display = 'none');
        const targetContent = document.getElementById(tab);
        if (targetContent) targetContent.style.display = 'block';
        updateFilterVisibility(tab);
        document.querySelectorAll(".search_tab-button").forEach(btn => btn.classList.remove("search_tab_active"));
        this.classList.add("search_tab_active");
      });
    });

    
  }

  // --- 应用启动 ---
  // 添加一个日志来确认事件监听器是否被设置
  console.log('[INIT] Setting up DOMContentLoaded event listener.');
  
  if (document.readyState === 'loading') {
    console.log('[INIT] Document is still loading, adding event listener.');
    document.addEventListener('DOMContentLoaded', initializeApp);
  } else {
    console.log('[INIT] Document is already loaded, calling initializeApp directly.');
    // 如果 DOM 已经加载完成，则直接执行
    initializeApp();
  }

  console.log('[INIT] Script setup complete.');

})();